'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var AccordionItem = require('./AccordionItem.js');
var utils = require('@chakra-ui/utils');
var React = require('react');
var useAccordion = require('./useAccordion.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * AccordionPanel
 *
 * Holds the content for each accordion. It shows and hides based on the state
 * login from the `AccordionItem`.
 *
 * It uses the `Collapse` component to animate its height.
 */
var AccordionPanel = react.forwardRef(function (props, ref) {
  var _useAccordionContext = useAccordion.useAccordionContext(),
    reduceMotion = _useAccordionContext.reduceMotion;
  var _useAccordionItemCont = AccordionItem.useAccordionItemContext(),
    getPanelProps = _useAccordionItemCont.getPanelProps,
    isOpen = _useAccordionItemCont.isOpen;

  // Remove `hidden` prop because we're using height-based animations.
  var panelProps = getPanelProps(props, ref);
  var _className = utils.cx('chakra-accordion__panel', props.className);
  var styles = react.useStyles();
  if (!reduceMotion) {
    delete panelProps.hidden;
  }
  var child = /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({}, panelProps, {
    __css: styles.panel,
    className: _className
  }));
  if (!reduceMotion) {
    return /*#__PURE__*/React__default["default"].createElement(react.Collapse, {
      "in": isOpen
    }, child);
  }
  return child;
});
AccordionPanel.displayName = 'AccordionPanel';
exports.AccordionPanel = AccordionPanel;